import React from 'react'
import { PendingContainer, PendingScrollContainer, PendingTable, PendingValidationCell, ValidationStatus } from '../upload'
import { PendingIncomingFields } from './validateIncomingParseResult'
import { Locale, Translation } from 'locale'
import { HaircutTypeHelper, Severity, SpreadsheetSettlementVenueHelper } from 'model'
import { IncomingPriceUpload } from './IncomingUploadDialog'
import { isNotEmpty } from 'utils/predicate'

export interface PendingIncomingPanelProps {
  priceUploads: IncomingPriceUpload[]
}

const PendingPanel: React.FC<PendingIncomingPanelProps> = ({ priceUploads }) => {
  return (
    <PendingScrollContainer>
      <PendingTable>
        <thead>
          <tr>
            <th>{Locale.translate(Translation.TC_RFQ_ID)}</th>
            <th>{Locale.translate(Translation.TC_NEGOTIATION_ID)}</th>
            <th>{Locale.translate(Translation.TC_RATE)}</th>
            <th>{Locale.translate(Translation.TC_HAIRCUT)}</th>
            <th>{Locale.translate(Translation.TC_HAIRCUT_TYPE)}</th>
            <th>{Locale.translate(Translation.TC_SETTLEMENT_TYPE)}</th>
          </tr>
        </thead>
        <tbody>
          {priceUploads.map((priceUpload, idx) => {
            const { rfqId, negotiationId, rate, haircut, haircutType, settlementType, dataIssues } = priceUpload
            const hasWarnings = isNotEmpty(dataIssues.filter(i => i.severity === Severity.WARN))
            const hasErrors = isNotEmpty(dataIssues.filter(i => i.severity === Severity.ERROR))
            const rowValidationStatus = hasErrors ? ValidationStatus.ERROR : hasWarnings ? ValidationStatus.WARN : ValidationStatus.DEFAULT

            return (
              <tr key={idx}>
                <PendingValidationCell
                  fieldName={PendingIncomingFields.RFQ_ID}
                  rowValidationStatus={rowValidationStatus}
                  validationIssues={dataIssues}>
                  {rfqId}
                </PendingValidationCell>
                <PendingValidationCell
                  fieldName={PendingIncomingFields.NEGOTIATION_ID}
                  rowValidationStatus={rowValidationStatus}
                  validationIssues={dataIssues}>
                  {negotiationId}
                </PendingValidationCell>
                <PendingValidationCell fieldName={PendingIncomingFields.RATE} validationIssues={dataIssues}>
                  {Locale.formatNumber(rate, { percent: true })}
                </PendingValidationCell>
                <PendingValidationCell fieldName={PendingIncomingFields.HAIRCUT} validationIssues={dataIssues}>
                  {Locale.formatNumber(haircut, { percent: true })}
                </PendingValidationCell>
                <PendingValidationCell fieldName={PendingIncomingFields.HAIRCUT_TYPE} validationIssues={dataIssues}>
                  {haircutType && HaircutTypeHelper.getName(haircutType)}
                </PendingValidationCell>
                <PendingValidationCell fieldName={PendingIncomingFields.SETTLEMENT_TYPE} validationIssues={dataIssues}>
                  {settlementType && SpreadsheetSettlementVenueHelper.getName(settlementType)}
                </PendingValidationCell>
              </tr>
            )
          })}
        </tbody>
      </PendingTable>
    </PendingScrollContainer>
  )
}

export const PendingIncomingPanel: React.FC<PendingIncomingPanelProps> = ({ priceUploads }) => {
  return (
    <PendingContainer>
      <h4>{Locale.translate(Translation.TC_PENDING_PRICE_UPLOADS)}</h4>
      <PendingPanel priceUploads={priceUploads} />
    </PendingContainer>
  )
}
